export const GLOBAL_ERROR =
  "Une erreur s'est produite, veuillez ressayer plus tard";
